<template>
  <div style="display: contents">
    <slot name="icon" />
    <div>
      <slot name="text" />
      <div class="api-key-card__actions">
        <input
          id="apiKeyInput"
          class="api-key-card__input"
          :value="apiKeyLocal"
          readonly
        />
        <button
          type="button"
          class="api-key-card__button"
          aria-label="Copy API key to clipboard"
          @click="copyToClipboard"
        >
          <span
            class="mdi mdi-content-copy copy-icon"
            aria-hidden="true"
          />
        </button>
        <button
          type="button"
          class="api-key-card__button"
          aria-label="Open Konstantine page"
          @click="openKonstiPage"
        >
          <span
            class="mdi mdi-web web-icon"
            aria-hidden="true"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watchEffect } from 'vue'
import { useI18n } from 'vue-i18n'

import { showSnackbarMessage } from '@/lib/snackbarMessages'

const { t } = useI18n()
const props = defineProps({
  apiKey: String,
  status: String,
})
const apiKeyLocal = ref(props.apiKey ?? '')

watchEffect(() => {
  apiKeyLocal.value = props.apiKey ?? ''
})

const openKonstiPage = async () => {
  window.open('https://konsti.ai/', '_blank')
}

const copyToClipboard = async () => {
  try {
    await navigator.clipboard.writeText(apiKeyLocal.value)
    showSnackbarMessage('success', t('dashboard.konstantine.create-api.copied-api-key'))
  } catch (err) {
    const input = document.getElementById('apiKeyInput') as HTMLInputElement | null
    if (input) {
      input.select()
      document.execCommand?.('copy')
      showSnackbarMessage('success', t('dashboard.konstantine.create-api.copied-api-key'))
    }
  }
}
</script>

<style scoped>
.web-icon,
.copy-icon {
  color: #414142;
  font-size: 24px;
  cursor: pointer;
  z-index: 9;
}

.api-key-card__actions {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  margin-top: 10px;
}

.api-key-card__input {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  border-radius: 24px;
  border: none;
  outline: none;
  background-color: #ffffff;
  color: #414142;
  font-family: inherit;
  font-size: 14px;
  z-index: 9;
}

.api-key-card__button {
  border-radius: 25px;
  background-color: #e9ff5e;
  border: none;
  padding: 2px 8px;
  cursor: pointer;
  z-index: 9;
}
</style>
